<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <b-tabs pills>
                            <b-tab title="БИНО ИНШОАТ ТУРЛАРИ" active v-if="hasPermission('SETTINGS_CAD_SECTION')">
                                <CadastreSectionList/>
                            </b-tab>
                            <b-tab title="БИНО ТУРЛАРИ" v-if="hasPermission('SETTINGS_CAD_BUILDING')">
                                <CadastreBuildingList/>
                            </b-tab>
                            <b-tab title="БИНО КОНСТРУКТИВ ЭЛЕМЕНТЛАРИ" v-if="hasPermission('SETTINGS_CAD_BUILDING_CONSTRUCTIVE')">
                                <CadastreBuildingConstructiveFieldList />
                            </b-tab>
                            <b-tab title="БИНО ПАРАМЕТЕРЛАРИ" v-if="hasPermission('SETTINGS_CAD_BUILDING_FIELD')">
                                <CadastreBuildingFieldList/>
                            </b-tab>
                            <b-tab title="АМОРТИЗАЦИЯ ПАРАМЕТЕРЛАРИ" v-if="hasPermission('SETTINGS_CAD_BUILDING_DEPRECIATION')">
                                <CadastreBuildingDepreciationFieldList/>
                            </b-tab>
                            <b-tab title="РЕФЕРЕНСЛАР" v-if="hasPermission('SETTINGS_CAD_BUILDING_REFERENCE')">
                                <CadastreBuildingFieldReferenceList/>
                            </b-tab>
                            <b-tab title="БИНО ПАРАМЕТЕРЛАРИ(РЕГРЕССИЯ)" v-if="hasPermission('SETTINGS_CAD_BUILDING_FIELD_REGRESSION')">
                                <BuildingFieldOfRegression/>
                            </b-tab>
                            <b-tab title="РЕФЕРЕНСЛАР(РЕГРЕССИЯ)" v-if="hasPermission('SETTINGS_CAD_BUILDING_REFERENCE_REGRESSION')">
                                <BuildingFieldReferenceOfRegression/>
                            </b-tab>
                            <b-tab title="БИНО ИНШОАТ ТУРЛАРИ(РЕГРЕССИЯ)" v-if="hasPermission('SETTINGS_CAD_SECTION_REGRESSION')">
                                <BuildingSectionListOfRegression/>
                            </b-tab>
                            <b-tab title="ЧЕГАРАДОШ ХУДУДЛАР" v-if="hasPermission('SETTINGS_BUILDING_REGION_BORDER')">
                                <RegionBordersSettingList />
                            </b-tab>
                            <b-tab title="ЯИМДА КУРСАТИЛГАН ФАОЛИЯТ ТУРЛАРИ" v-if="hasPermission('SETTINGS_BUILDING_FUNCTION_TYPES_YIM')">
                                <FunctionTypesYim />
                            </b-tab>
                            <b-tab title="ҚУРИЛИШ МАТЕРИАЛЛАРИ" v-if="hasPermission('SETTINGS_BUILDING_MATERIALS')">
                                <BuildingMaterials />
                            </b-tab>
                            <b-tab title="БИНО ЭТАЖЛИЛИК КОЭФФИЦИЕНТИ" v-if="hasPermission('SETTINGS_BUILDING_STOREYS')">
                                <BuildingStoreys />
                            </b-tab>
                            <b-tab title="КАДАСТР МАЪЛУМОТЛАРИ" v-if="hasPermission('REAL_ESTATE_CAD_HISTORICAL')">
                                <CadastreHistoricalList />
                            </b-tab>
                            <b-tab title="ҚИММАТЛАШ ИНДЕКСЛАРИ" v-if="hasPermission('SETTINGS_CAD_BUILDING_INDEX')">
                                <CadastreBuildingIndexList />
                            </b-tab>
                            <b-tab title="ЕР СОЛИҚ СТАВКАЛАРИ" v-if="hasPermission('SETTINGS_BUILDING_TAX_RATE_FOR_LAND')">
                                <TaxRateForLandList />
                            </b-tab>
                            <b-tab title="ЕР ИЖАРА СТАВКАЛАРИ" v-if="hasPermission('SETTINGS_BUILDING_RENT_RATE_FOR_LAND')">
                                <RentRateForLandList />
                            </b-tab>
                            <b-tab title="БОШҚА КОНТРАКТ СЎММАЛАРИ(Иссиқхона,Кўл,Боғлар)" v-if="hasPermission('SETTINGS_BUILDING_OTHER_CONTRACT_AMOUNT')">
                                <LightConstructiveElementContractAmountList />
                            </b-tab>
                            <b-tab title="БОЗОР ТАҲЛИЛИ" v-if="hasPermission('SETTINGS_BUILDING_MARKET_ANALYSIS')">
                                <RealEstateMarketAnalysisList />
                            </b-tab>
                            <b-tab title="АНАЛОГ СОЗЛАШ" v-if="hasPermission('SETTINGS_BUILDING_ANALOG_SETTING')">
                                <AnalogSettingList />
                            </b-tab>
                            <b-tab title="АНАЛОГ ЕР СОЗЛАШ" v-if="hasPermission('SETTINGS_BUILDING_ANALOG_LAND_SETTING')">
                                <AnalogLandSettingsList />
                            </b-tab>
                            <b-tab title="ТАДБИРКОРЛИК КОЭФИЦИЕНТИ" v-if="hasPermission('SETTINGS_BUILDING_BUSINESS_COEFFICIENT')">
                                <BusinessCoefficientList />
                            </b-tab>
                            <b-tab title="БОШКА СОЗЛАМАЛАР" v-if="hasPermission('SETTINGS_BUILDING_OTHER_SETTINGS')">
                                <OtherSettingsList />
                            </b-tab>
                            <b-tab title="КАТТА КИЧИКЛИГИ" v-if="hasPermission('SETTINGS_BUILDING_CADASTRE_FIX_SIZE')">
                                <CadastreFixSizeList />
                            </b-tab>
                            <b-tab title="КАТТА КИЧИКЛИГИГА ТУЗАТИШ ТУРЛАРИ" v-if="hasPermission('SETTINGS_BUILDING_CADASTRE_FIX_SIZE_TYPE')">
                                <CadastreFixSizeTypeList />
                            </b-tab>
                            <b-tab title="КАТТА КИЧИКЛИГИГА БИНО ТУРЛАРИ" v-if="hasPermission('SETTINGS_BUILDING_CADASTRE_BUILDING_FIX_SIZE')">
                                <CadastreBuildingFixSizeList />
                            </b-tab>
                            <b-tab title="ФОРМУЛА КУРИЛГАН ДАВРИ" v-if="hasPermission('SETTINGS_BUILDING_FORMULA_HOUSING_TYPE')">
                                <FormulaList :type="'HousingType'" :name="'Курилган даври'"/>
                            </b-tab>
                            <b-tab title="ФОРМУЛА АЛОХИДА БИНО" v-if="hasPermission('SETTINGS_BUILDING_FORMULA_SEPARATE_BUILDING')">
                                <FormulaList :type="'SeparateBuilding'" :name="'Алоҳида бино'"/>
                            </b-tab>
                            <b-tab title="ФОРМУЛА ЕРТЎЛА ТУРИ" v-if="hasPermission('SETTINGS_BUILDING_FORMULA_BASEMENT_TYPE')">
                                <FormulaList :type="'BasementBuildingType'" :name="'Ертўла тури'"/>
                            </b-tab>
                            <b-tab title="ФОРМУЛА ДАВРГА НИСБАТАН" v-if="hasPermission('SETTINGS_BUILDING_FORMULA_PERIOD')">
                              <FormulaList :type="'BuildingPeriod'" :name="'Даврга нисбатан'"/>
                            </b-tab>
                            <b-tab title="ФОРМУЛА ЕР ДАВРГА НИСБАТАН" v-if="hasPermission('SETTINGS_BUILDING_FORMULA_PERIOD')">
                              <FormulaList :type="'BuildingPeriodOfLand'" :name="'Ер участкасини қуриш даври'"/>
                            </b-tab>
                            <b-tab title="ФОРМУЛА ҚАВАТГА НИСБАТАН" v-if="hasPermission('SETTINGS_BUILDING_FORMULA_STOREYS')">
                              <FormulaList :type="'BuildingStoreys'" :name="'Қаватга нисбатан'"/>
                            </b-tab>
                            <b-tab title="ФОРМУЛА ЛИФТ МАВЖУДЛИГИ" v-if="hasPermission('SETTINGS_BUILDING_FORMULA_ELEVATOR')">
                              <FormulaList :type="'elevator'" :name="'Лифт мавжудлиги'"/>
                            </b-tab>
                            <b-tab title="ФОРМУЛА МАРКАЗДАН УЗОҚЛИК" v-if="hasPermission('SETTINGS_BUILDING_FORMULA_CITY_CENTER')">
                              <FormulaList :type="'BuildingCityCenter'" :name="'Марказдан узоқлик'"/>
                            </b-tab>
                            <b-tab title="ФОРМУЛА АЛОХИДА КУЛАЙЛИК" v-if="hasPermission('SETTINGS_BUILDING_FORMULA_SPECIAL_COMFORT')">
                              <FormulaList :type="'SpecialComforts'" :name="'Алохида кулайлик'"/>
                            </b-tab>
                            <b-tab title="ФОРМУЛА ТУМАН ТУЗАТУВЧИ КОЭФИЦИЕНТ" v-if="hasPermission('SETTINGS_BUILDING_FORMULA_REGION_COEFFICIENT')">
                              <FormulaList :type="'RegionCorrectionCoefficient'" :name="'Туман тузатувчи коэфициент'"/>
                            </b-tab>
                            <b-tab title="ЯНГИ АНАЛОГ СОЗЛАШ" v-if="hasPermission('SETTINGS_BUILDING_ANALOG_SETTING')">
                              <AnalogSettingCalculateList />
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bTabs from 'bootstrap-vue/es/components/tabs/tabs';
    import bTab from 'bootstrap-vue/es/components/tabs/tab';
    import CadastreSectionList from '@/views/config/cadastre/CadastreSectionList';
    import CadastreBuildingList from '@/views/config/cadastre/CadastreBuildingList';
    import CadastreBuildingFieldList from '@/views/config/cadastre/CadastreBuildingFieldList';
    import CadastreBuildingDepreciationFieldList from '@/views/config/cadastre/CadastreBuildingDepreciationFieldList';
    import CadastreBuildingFieldReferenceList from '@/views/config/cadastre/CadastreBuildingFieldReferenceList';
    import BuildingFieldOfRegression from '@/views/config/real-estate-regression/BuildingFieldList'
    import BuildingFieldReferenceOfRegression from '@/views/config/real-estate-regression/BuildingFieldReferenceList'
    import BuildingSectionListOfRegression from '@/views/config/real-estate-regression/BuildingSectionList'
    import RegionBordersSettingList from '@/views/config/real-estate/RegionBordersSettingList'
    import FunctionTypesYim from '@/views/config/real-estate/FunctionTypesYim'
    import BuildingMaterials from '@/views/config/real-estate/BuildingMaterials'
    import BuildingStoreys from '@/views/config/real-estate/BuildingStoreys'
    import CadastreHistoricalList from '@/views/config/cadastre/CadastreHistoricalList';
    import CadastreBuildingIndexList from "@/views/config/cadastre/CadastreBuildingIndexList";
    import TaxRateForLandList from "@/views/config/real-estate/TaxRateForLandList";
    import LightConstructiveElementContractAmountList from "@/views/config/real-estate/LightConstructiveElementContractAmountList";
    import RealEstateMarketAnalysisList from "@/views/config/market-analysis/RealEstateMarketAnalysisList";
    import AnalogSettingList from "@/views/config/real-estate/AnalogSettingList"
    import CadastreBuildingConstructiveFieldList from '@/views/config/cadastre/CadastreBuildingConstructiveFieldList.vue'
    import AnalogLandSettingsList from "@/views/config/real-estate/AnalogLandSettingsList";
    import BusinessCoefficientList from "@/views/config/real-estate/BusinessCoefficientList"
    import OtherSettingsList from "@/views/config/real-estate/OtherSettingsList";
    import RentRateForLandList from "@/views/config/real-estate/RentRateForLandList";
    import CadastreFixSizeTypeList from "@/views/config/cadastre/CadastreFixSizeTypeList"
    import CadastreFixSizeList from "@/views/config/cadastre/CadastreFixSizeList"
    import CadastreBuildingFixSizeList from "@/views/config/cadastre/CadastreBuildingFixSizeList"
    import FormulaList from "@/views/config/real-estate/FormulaList";
    import AnalogSettingCalculateList from "@/views/config/real-estate/analog-setting/AnalogSettingCalculateList.vue";

    export default {
        name: "CadastreConfig",
        components: {
            AnalogSettingCalculateList,
            RentRateForLandList,
            AnalogLandSettingsList,
            'b-tabs': bTabs,
            'b-tab': bTab,
            CadastreBuildingList,
            CadastreBuildingFieldList,
            CadastreBuildingDepreciationFieldList,
            CadastreBuildingFieldReferenceList,
            BuildingFieldOfRegression,
            BuildingFieldReferenceOfRegression,
            BuildingSectionListOfRegression,
            RegionBordersSettingList,
            FunctionTypesYim,
            BuildingMaterials,
            BuildingStoreys,
            CadastreHistoricalList,
            CadastreSectionList,
            CadastreBuildingIndexList,
            TaxRateForLandList,
            LightConstructiveElementContractAmountList,
            RealEstateMarketAnalysisList,
            AnalogSettingList,
            CadastreBuildingConstructiveFieldList,
            BusinessCoefficientList,
            OtherSettingsList,
            CadastreFixSizeTypeList,
            CadastreBuildingFixSizeList,
            CadastreFixSizeList,
            FormulaList
        }
    }
</script>

<style scoped>

</style>